import { render, staticRenderFns } from "./ChecklistItems.vue?vue&type=template&id=cb1773d2&"
import script from "./ChecklistItems.vue?vue&type=script&lang=js&"
export * from "./ChecklistItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports